<template>
  <main :key="code">
    <div :class="parseFloat(av) > 0 ? 'good' : 'bad'">
      <div class="name fx">
        <span>
          <b>{{ title }}</b>
          <P :class="parseFloat(av) > 0 ? 'en' : 'ens'">{{ EngLish }}</P>
        </span>
      </div>
      <div class="desc">{{ $route.query.showDiet ?  desc:explain }}</div>
      <div class="pointer-container">
        <div
          :class="parseFloat(av) > 0 ? 'pointer-values' : 'pointer-value'"
          :style="getPointerStyle()"
        >
          {{ av }}
        </div>
        <div class="scale-container">
          <div class="scale-marks">
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">异常</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-4.0</div>
            <div :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-3.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-2.0</div>
            <div :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">-1.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">正常</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+1.0</div>
            <div :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+2.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+3.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">+4.0</div>
            <div  :class="parseFloat(av) > 0 ? 'scale-markss' : 'scale-mark'">优异</div>
          </div>
          <div class="scale-line"></div>
        </div>
      </div>
    </div>

    <DynamicTrackingCard
      title="动态数据跟踪"
      :data="healthDatas"
      initialValueKey="initialValue"
      finalValueKey="finalValue"
      labelKey="name"
      :showLegend="true"
    />

    <SectionView title="影响身体关联项">
      <div class="relation-items">
        <div
          v-for="(item, index) in  relations"
          :key="index"
          class="relation-item"
          :class="parseFloat(item.av) < 0 ? 'negative-item' : 'positive-item'"
          @click="openTissue(index)"
        >
          <div class="item-content">
            <span>{{ item.item_dict_name }}</span>
            <img src="../assets/图标-进入.png" alt="" />
          </div>
        </div>
      </div>
      <!-- <div class="relation-items">
        <div
          v-for="(item, index) in relations"
          :key="index"
          class="relation-item"
          @click="openTissue(index)"
        >
          <div class="item-content">
            <span>{{ item.item_dict_name }}</span>
            <img src="../assets/图标-进入.png" alt="" />
          </div>
        </div>
      </div> -->
    </SectionView>
    <SectionView title="饮食建议" v-if="$route.query.showDiet"
      ><div class="full-health-info-desc">{{ yh }}</div></SectionView
    >
    <SectionView title="运动建议" v-if="$route.query.showDiet"
      ><div class="full-health-info-desc">{{ yd }}</div></SectionView
    >
    <SectionView title="起居建议" v-if="$route.query.showDiet"
      ><div class="full-health-info-desc">{{ qj }}</div></SectionView
    >
    <SectionView title="项目说明"  v-if="!$route.query.showDiet"
      ><div class="full-health-info-desc">{{ desc }}</div>
      <div class="full-health-info-descs">{{ food }}</div>
      </SectionView
    >
    <div class="full-health-info-button-container">
      <router-link
        class="full-health-info-button"
        :to="{ path: '/overview', query }"
        >查看全面健康信息</router-link
      >
    </div>
    <div class="horizontal-line" v-if="!$route.query.showDiet" ></div>
    <SectionView title="食物来源"  v-if="!$route.query.showDiet">
      <div class="food-source-container">
        <div v-if="foods && foods.length > 0" class="food-source-grid">
          <div v-for="(item, index) in foods" :key="index" class="food-item">
            <img :src="item.url" :alt="item.name" class="food-image">
            <div class="food-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      </SectionView>
    

    <diet-card
      v-if="diets.useless.length > 0 || diets.useful.length > 0"
      :useless="diets.useless"
      :useful="diets.useful"
    ></diet-card>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"
        ><i :style="{ background: item.color }"></i>{{ item.str }}</span
      >
    </dialog-view>
  </main>
</template>

<script>
import DietCard from "@/components/DietCard";
// import WaterfallCard from "@/components/WaterfallCard";
import {
  getReportLoopItemNutrition,
  getReportLoopItemOrgans,
  getReportFoodSource,
} from "../net/api";
import DialogView from "../components/DialogView";
import SectionView from "@/components/SectionView";
import DynamicTrackingCard from "../components/DynamicTrakingCard.vue";
// import ComparisonBarChart from "../components/ComparisonBarChart.vue";

export default {
  name: "Nutrition",
  components: {
    DialogView,
    DietCard,
    DynamicTrackingCard,
    SectionView,
  },

  data() {
    return {
      packageNo: "",
      checkcode: "",
      rand: "",
      activeTabIndex: 0,
      av: "",
      EngLish: "",
      foods: [],
      food: "",

      code: "",
      title: "",
      color: "#3BA272",
      status: "",

      // 介绍
      explain: "",
      qj: "",
      yh: "",
      yd: "",

      relations: [],
      healthDatas: [],

      desc: "",
      // 动态跟踪模式
      dynamics: [],
      // 饮食建议
      diets: {
        useful: [],
        useless: [],
      },
      stackValueKey: {
        one: "初值",
        two: "终值",
      },
      // 通用态图列表数据关联项
      statusValueKey: {
        av: "均值",
        one: "初值",
        two: "终值",
      },
      // 平均值关联项
      avValueKey: {
        av: "均值",
      },
      totalValueKey: {
        shice_value: "实测值",
        bili_value: "标准",
      },
      // 主要内脏关联比例图
      viscusRatios: [],
      // 主要营养素关联比例图
      nutritiveRatios: [],
      // 主要内脏平均值状态图
      viscusStatus: [],
      // 主要营养素平均值状态图
      nutritionStatus: [],

      // 运动建议
      sports: "",
      // 起居建议
      daily: "",

      // 报告等级列表
      levels: [],

      // 解读说明弹窗
      interpret: false,
      legends: [
        { name: "实测值", colors: [] },
        { name: "标准", colors: ["#C3C2C2"] },
      ],
    };
  },

  computed: {
    // 基础参数数据
    query() {
      return {
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      };
    },
  },

  created() {
    const query = this.$router.currentRoute.query;
    this.packageNo = query.packageNo;
    this.checkcode = query.checkcode;
    this.rand = query.rand;
    this.av = query.av;
    this.title = query.title;
    this.code = query.code;

    this.syncPageData();
    this. getFoodSource()
  },

  methods: {
    getPointerStyle() {
  const min = -5.0; // 异常对应的最小值
  const max = 5.0;  // 优异对应的最大值
  const value = parseFloat(this.av) || 0;
  const clampedValue = Math.max(min, Math.min(max, value)); // 限制值在 [-5, 5] 范围内

  // 计算百分比（0% 对应 -5.0，100% 对应 +5.0）
  const totalRange = max - min; // 10
  const percent = ((clampedValue - min) / totalRange) * 100;

  console.log("AV值:", value, "位置百分比:", percent);

  return {
    left: `${percent}%`,
    transform: "translateX(-50%)", // 保持指针中心点对齐
  };
},    // 同步页面数据
    syncPageData() {
      // 获取报告数据
      getReportLoopItemNutrition({
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,

        system_code: this.code,
      }).then((data) => {
        this.levels = data.colorData;
        this.EngLish = data.item_dict_name_en;
        this.propose = data.show_tiaoli;
        this.indicator = Number(data.show_zhibiao);
        this.relations = data.show_shentiguanlian;
        this.explain = data.show_tiaoli;
        this.desc = data.item_explain;
        this.lack = data.show_quefayihuan;
        this.food = data.show_shiwulaiyuan;
        this.dynamics = data.show_dongtai;
        this.averageStatus = data.show_pingjunzhi || [];
        console.log(data);
        if (this.dynamics && this.dynamics.length > 0) {
          this.healthDatas = this.dynamics.map((item) => ({
            initialValue: item.one,
            finalValue: item.two,
            name: item.time,
            av: item.av,
          }));
          // this.healthDatas=[...this.healthDatas,...this.healthDatas,...this.healthDatas,...this.healthDatas]
          // console.log('this.healthDatas)',this.healthDatas);
        }
        console.log(this.av);
      }),
        getReportLoopItemOrgans({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          system_code: this.code,
        }).then((data) => {
          this.yh = data.show_yinshi;
          this.yd = data.show_yundong;
          this.qj = data.show_qiju;
        });
    },
    openTissue(index) {
      const row = this.relations[index];
      if (!row) return;
      console.log(row);

      this.$router.replace({
        path: "/details",
        query: {
          av: row.av,
          code: row.system_code,
          title: row.item_dict_name,
          color: row.color,
          ...this.query,
        },
      });
    },
    getFoodSource() {
      // 构建请求URL和参数
      
      // 发起请求
      getReportFoodSource({
        flag:this.code,
      })
        .then(data => {
        this.foods=data.food_source_images
        console.log(this.foods)
        })
        .catch(error => {
          console.error("获取食物来源数据失败:", error);
        });
    },

  },
  mounted() {
    window.scrollTo(0, 0);
    console.log(1111)
  },
};
</script>

<style lang="scss" scoped>
main {
  color: #fff;
  padding: 0;
  padding-bottom: 70px;
  background-color: #F5F5F5;
  .bad {
    background-color: #ff5c4d;
    min-height: 168px;
  }
  .good {
    background-color: #003cbf;
    min-height: 168px;
  }
  .name {
    position: relative;
    padding-top: 30px;
    text-align: center;

    span {
      position: relative;
      padding: 0 10px;
    }

    b {
      position: relative;
      font-size: 50px;
      color: #ffffff;
      line-height: 70px;
      font-weight: 500;
      text-align: center;
    }
  }
  .en{
    font-weight: 400;
font-size: 24px;
color: #CBE2FF;
line-height: 22px;
text-align: center;
font-style: normal;
text-transform: none;
margin-top: 8px;
margin-bottom: 18px;
  }
  .ens{
    color: #FFD5D5;
    font-weight: 400;
font-size: 24px;
line-height: 22px;
text-align: center;
font-style: normal;
text-transform: none;
margin-top: 8px;
margin-bottom: 18px;
  }
  .desc {
font-family: PingFang SC, PingFang SC;
font-weight: 400;
font-size: 22px;
color: #FFFFFF;
line-height: 40px;
text-align: center;
font-style: normal;
text-transform: none;
margin-left: 72px;
white-space: pre-line;
margin-right: 68px;
  }

  .pointer-container {
    position: relative;
  width: 100%; /* 或固定宽度，如600px */
  box-sizing: border-box;
  margin: 0 auto;

    .pointer-value {
      background-color: #fff;
      color: #ff5c4d;
      font-size: 24px;
      font-weight: bold;
      width: 80px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 20px;
      position: absolute;
      bottom: 54px;
      transform: translateX(-50%);
      z-index: 2;

      &:after {
        content: "";
        position: absolute;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;

        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #fff;
      }
    }

    .scale-container {
      position: relative;
      height: 80px;
      margin-top: 50px;

      .scale-line {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 4px;
        background-color: rgba(219, 201, 201, 0.3);
      }

      .scale-marks {
        display: flex;
        justify-content: space-between;
        position: absolute;
        bottom: 10px;
        padding:0 ; /* 确保无内边距影响位置计算 */
        left: 0;
        right: 0;

        .scale-mark {
          width: 100%; /* 平均分配宽度 */
          font-size: 23px;
          position: relative;
          color: #FFE8E5;

          &:before {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 12px;
            background-color: #ffe8e6;
          }
        }
        .scale-markss {
          width: 100%; /* 平均分配宽度 */
          font-size: 23px;
          position: relative;
          color: #D0DEFF;

          &:before {
            content: "";
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 4px;
            height: 12px;
            background-color: #ffe8e6;
          }
        }
      }

      .pointer {
        position: absolute;
        bottom: 0;
        width: 4px;
        height: 20px;
        background-color: #fff;
        transform: translateX(-50%);
        z-index: 1;
      }

      .left-percent {
        position: absolute;
        bottom: 30px;
        left: 0;
        font-size: 14px;
      }

      .right-percent {
        position: absolute;
        bottom: 30px;
        right: 0;
        font-size: 14px;
      }
    }
  }
  .relation-items {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 0 20px 20px;

    .relation-item {
      background-color: #FDFDFD;
      border-radius: 6px;
      overflow: hidden;
      width: 200px;
      margin-right:10px;
      margin-top: 10px;
      margin-bottom: 10px;
          height: 76px;
      position: relative;
      border: 1px solid #E9E9E9;
      &.negative-item {
        color: #FF5C4D;
        background-color: #FFFAFA;
        border: 1px solid #FFDEDE;
      }
      
      &.positive-item {
        color:#003CBF;
        background-color: #F4F9FF;
        border: 1px solid #DCE2FF;
      }

      .item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 15px;
        min-height: 20px;

        span {
          font-weight: 500;
          font-size: 27px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        img {
          width: 30px;
          height: 30px; /* 图标高度，可根据实际调整 */
          object-fit: contain; /* 保持图片比例，避免拉伸变形 */
        }
      }

      // 第二个项目（肝功能）使用默认黑色
    }
  }
  .horizontal-line {
    border-bottom: 2px solid #cccccc;
    height: 0;
    margin: 15px 0; /* 设置上下 margin 为 10px */
  }
  .full-health-info-button-container {
    padding: 20px 30px;
    margin: 20px 0;
  }

  .full-health-info-button {
    width: 100%;
    height: 90px;
    background-color: #0052d9;
    color: white;
    border: none;
    border-radius: 45px;
    font-size: 32px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 8px rgba(0, 82, 217, 0.2);
    text-decoration: none;
    cursor: pointer;
  }
}
.pointer-values {
  background-color: #fff;
  color: #2026e3;
  font-size: 24px;
  font-weight: bold;
  width: 80px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 20px;
  position: absolute;
  margin-bottom: 10px;
  transform: translateX(-50%);
  z-index: 2;
  &:after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid #fff;
  }
}
.full-health-info-desc {
  width: 700px;
  margin-left: 15px;
  margin-right: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 26px;
  color: #495880;
  line-height: 42px;
  text-align: justified;
  font-style: normal;
  text-transform: none;
  white-space: pre-line;
}
.full-health-info-descs{
  margin-top: 40px;
  font-family: PingFang SC, PingFang SC;
font-weight: 400;
margin-left: 15px;
margin-right: 20px;
font-size: 22px;
color: #808080;
line-height: 44px;
text-align: justified;
font-style: normal;
text-transform: none;
white-space: pre-line;

}
.food-source-container {
  padding: 10px 0;
  margin-bottom:30px ;
  margin-left: 10px;
  
  .food-source-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
    
    .food-item {
      width: 150px;
      display: flex;
      padding-left: 5px;
      flex-direction: column;
      align-items: center;
      margin-bottom: 20px;
      
      .food-image {
        width: 70px;
        height: 70px;
        object-fit: cover;
        margin-bottom: 12px;
      }
      
      .food-name {
        font-weight: 400;
font-size: 28px;
color: #00133D;
line-height: 14px;
text-align: center;
font-style: normal;
text-transform: none;
      }
    }
  }
}
</style>
